import { SearchInput as DSSearchInput } from 'uyari-design-system'

interface SearchInputProps {
  placeholder?: string
  value: string
  onChange: (value: string) => void
  className?: string
}

export function SearchInput({
  placeholder = 'Buscar...',
  value,
  onChange,
  className,
}: SearchInputProps) {
  return (
    <div className={className}>
      <DSSearchInput
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  )
}
